import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject, ComputedRef, watch } from 'vue';

import {
  Modal,
  ButtonContainer,
  ButtonPrimary,
  HeadingDisplay,
  SelectionBox,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { ModalStepTransition } from '@/modules/common/components/ModalStepTransition';
import { Portal } from '@/modules/common/components/Portal';

import { PaidEventsConfigurationSteps } from './types';
import {
  PortfolioPaidEventConfiguration,
  updatePaidEventsDestination
} from '@/modules/wealth/services/portfolio';

interface Props {
  isOpen: boolean;
  paidEventsConfiguration?: PortfolioPaidEventConfiguration;
}
interface Emits {
  (e: 'close'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PaidEventsConfigurationModal',
  props: {
    isOpen: { type: Boolean },
    paidEventsConfiguration: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
  paidEventsConfiguration?: PortfolioPaidEventConfiguration;
}





const currentStep = ref(PaidEventsConfigurationSteps.Selection);
const option = ref('');
const isLoading = ref(false);
const statusMessage = ref({
  status: 'negative',
  title: 'Houve um problema ao configurar proventos',
  description: 'Aguarde uns instantes e tente novamente',
  buttonLabel: ''
});

const portfolioId = inject('portfolioId') as ComputedRef<string>;
const refreshPortfolioDetails = inject('refreshPortfolioDetails') as Function;

watch(
  () => props.isOpen,
  () => {
    option.value = props.paidEventsConfiguration?.form.selectedIndex || '';
    if (props.paidEventsConfiguration?.enabled === false && props.isOpen) {
      currentStep.value = PaidEventsConfigurationSteps.Status;
      statusMessage.value = {
        status: 'information',
        title: props.paidEventsConfiguration?.blockedStatus?.title || '',
        description:
          props.paidEventsConfiguration?.blockedStatus?.description || '',
        buttonLabel: ''
      };
    }
  },
  { immediate: true }
);

const isPaidEventsConfigurationEnabled = computed(() => {
  return !!props.paidEventsConfiguration?.enabled;
});

const formTitle = computed(() => {
  return props.paidEventsConfiguration?.form?.title || '';
});

const formDescription = computed(() => {
  return props.paidEventsConfiguration?.form?.description || '';
});

const formOptions = computed(() => {
  return (
    props.paidEventsConfiguration?.form?.options.map(option => {
      return {
        title: option.formatted,
        value: option.value
      };
    }) || []
  );
});

const hasOptionSelected = computed(() => {
  return !!option.value;
});

const handleClose = () => {
  if (isPaidEventsConfigurationEnabled.value)
    currentStep.value = PaidEventsConfigurationSteps.Selection;
  option.value = '';

  emit('close');
};

const handleSubmit = async () => {
  if (!hasOptionSelected.value) return;

  try {
    isLoading.value = true;

    const response = await updatePaidEventsDestination({
      portfolioId: portfolioId.value,
      paidEventDestination: option.value
    });

    statusMessage.value = {
      ...response,
      buttonLabel: ''
    };

    refreshPortfolioDetails();
  } catch {
    statusMessage.value = {
      status: 'negative',
      title: 'Houve um problema ao configurar proventos',
      description: 'Aguarde uns instantes e tente novamente',
      buttonLabel: 'Tentar novamente'
    };
  } finally {
    currentStep.value = PaidEventsConfigurationSteps.Status;
    isLoading.value = false;
  }
};

const handleChangeOption = (value: string) => {
  option.value = value;
};

return { __sfc: true,props, emit, currentStep, option, isLoading, statusMessage, portfolioId, refreshPortfolioDetails, isPaidEventsConfigurationEnabled, formTitle, formDescription, formOptions, hasOptionSelected, handleClose, handleSubmit, handleChangeOption, Modal, ButtonContainer, ButtonPrimary, HeadingDisplay, SelectionBox, HelperViewStatus, ModalStepTransition, Portal, PaidEventsConfigurationSteps }
}

})